import { useEffect } from "react";
import { useAuth } from "react-oidc-context";

const AuthTokenSync = () => {
  const auth = useAuth();

  useEffect(() => {
    if (auth.user?.access_token) {
      localStorage.setItem("auth-token", auth.user.access_token);
    }
  }, [auth.user?.access_token]);

  useEffect(() => {
    if (!auth.isAuthenticated && !auth.isLoading) {
      localStorage.removeItem("auth-token");
    }
  }, [auth.isAuthenticated, auth.isLoading]);

  return null;
};

export default AuthTokenSync;
